
import { useState, useEffect } from 'react';
import { Container, Icon, Content, VoicePreview, LoadSend } from './styled';
import { MediaDevices } from '../../class';
import { IoCheckmarkSharp, IoSend } from 'react-icons/io5';
import { IoMdTrash } from 'react-icons/io';
import { sendVoiceMic } from '../../service/serviceChat/chatService';

export function VoiceRecorder(props) {
    const { start, setStart, to, accessLevel } = props;

    const [isActiveTime, setIsActiveTime] = useState(false);
    const [time, setTime] = useState(0);
    const [voice, setVoice] = useState(false);
    const [stream, setStream] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(false);
    const [loading, setLoading] = useState(false);

    const notPermission = () => {
        setStart(false);
        alert("Por favor, habilite o microfone 🎙️");
    };
    
    const media = new MediaDevices(notPermission);

    useEffect(() => {
        clear();
        if (start) {
            onStartRecorder();   
        }
    }, [start]);
    useEffect(() => {
        if (stream) {
            setMediaRecorder(new MediaRecorder(stream));
        }
    }, [stream]);
    useEffect(() => {
        if (mediaRecorder) {
            mediaRecorder.start();
            setIsActiveTime(true);
            let chunks = [];
            mediaRecorder.ondataavailable = (e) => {
                chunks.push(e.data);
            };
            mediaRecorder.onstop = () => {
                stream.getTracks().forEach(t => t.stop());
                setIsActiveTime(false);
                setTime(0);
                const blob = new Blob(chunks, { type: 'audio/webm;codecs=opus' });
                const file = new File([blob], "audio", { type: "audio/webm;codecs=opus" });
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = (e) => {
                    setVoice({ file: file, url: reader.result });
                };
            };
        }
    }, [mediaRecorder, stream]);
    useEffect(() => {
        let interval = null;
        if (isActiveTime) {
            interval = setInterval(() => {
                setTime((time) => time + 1);
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => {
            clearInterval(interval);
        };
    }, [isActiveTime]);

    const clear = () => {
        setVoice(false);
        setIsActiveTime(false);
        setTime(0);
        setStream(false);
        setMediaRecorder(false);
    };
    const formatTime = () => {
        const getSeconds = `0${(time % 60)}`.slice(-2);
        const getMinutes = `${`${Math.floor(time / 60)}` % 60}`.slice(-2);
        return (`${getMinutes}:${getSeconds}`);
    };
    const onStartRecorder = async () => {
        setStream(await media.getAudio());
    };
    const onSaveRecorder = () => {
        mediaRecorder.stop();
    };
    const onCloseRecorder = () => {
        setStart(false);
        stream.getTracks().forEach(t => t.stop());
    };
    const onSandAudio = async (file) => {
        setLoading(true);
        await sendVoiceMic(file, to);
        setLoading(false);
        setStart(false);
        return;
    };

    return (
        <Container isOpen={start ? 1 : 0} accessLevel={accessLevel}>
            <Content isDisabled={loading} accessLevel={accessLevel}>
                <div>
                    <Icon>
                        <IoMdTrash className='trash' onClick={onCloseRecorder} />
                    </Icon>
                </div>
                <div className='center'>
                    {!voice
                        ? (
                            <div className='time'>
                                <Icon>
                                    <div className='blob-recorder'>
                                    </div>
                                </Icon>
                                <span className='time'>{formatTime()}</span>
                            </div>
                        )
                        : (
                            <VoicePreview src={voice.url} controls={true} />
                        )}
                </div>
                <div>
                    {!voice ? (
                        <Icon>
                            <IoCheckmarkSharp
                                className='save'
                                onClick={onSaveRecorder}
                            />
                        </Icon>
                    ) : (
                        <Icon>
                            {!loading ? (
                                <IoSend
                                    className='sendVoice'
                                    onClick={() => onSandAudio(voice.file)}
                                />
                            ) : (
                                <LoadSend />
                            )}
                        </Icon>
                    )}
                </div>
            </Content>
        </Container>
    );
};